/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online CSV to JSON converter and JSON to CSV converter. Handles quoted fields, commas, and newlines. Paste your data and convert instantly in your browser.`)
};

const es_cj_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor gratuito en línea de CSV a JSON y de JSON a CSV. Gestiona campos entre comillas, comas y saltos de línea. Pega tus datos y convierte al instante en tu navegador.`)
};

const de_cj_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Konverter für CSV zu JSON und JSON zu CSV. Verarbeitet in Anführungszeichen gesetzte Felder, Kommas und Zeilenumbrüche. Daten einfügen und sofort im Browser konvertieren.`)
};

const nl_cj_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online CSV naar JSON-converter en JSON naar CSV-converter. Verwerkt velden tussen aanhalingstekens, komma's en regelinvoegingen. Plak uw gegevens en converteer onmiddellijk in uw browser.`)
};

const fr_cj_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur en ligne gratuit CSV en JSON et JSON en CSV. Gère les champs entre guillemets, les virgules et les sauts de ligne. Collez vos données et convertissez instantanément dans votre navigateur.`)
};

const it_cj_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore online gratuito da CSV a JSON e da JSON a CSV. Gestisce campi tra virgolette, virgole e interruzioni di riga. Incolla i tuoi dati e converti istantaneamente nel tuo browser.`)
};

const pt_br2_cj_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito online de CSV para JSON e de JSON para CSV. Trata campos entre aspas, vírgulas e quebras de linha. Cole seus dados e converta instantaneamente no seu navegador.`)
};

const pt_cj_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor online gratuito de CSV para JSON e de JSON para CSV. Suporta campos entre aspas, vírgulas e quebras de linha. Cole os seus dados e converta instantaneamente no seu navegador.`)
};

const ja_cj_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の CSV から JSON コンバーターと JSON から CSV コンバーター。引用符付きフィールド、コンマ、改行を処理します。データを貼り付けてブラウザで即座に変換します。`)
};

const zh_cj_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线 CSV 转 JSON 及 JSON 转 CSV 转换器。可处理带引号的字段、逗号和换行符。粘贴数据即可在浏览器中即时转换。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_meta_description", locale)
	if (locale === "en") return en_cj_meta_description(inputs)
	if (locale === "es") return es_cj_meta_description(inputs)
	if (locale === "de") return de_cj_meta_description(inputs)
	if (locale === "nl") return nl_cj_meta_description(inputs)
	if (locale === "fr") return fr_cj_meta_description(inputs)
	if (locale === "it") return it_cj_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_cj_meta_description(inputs)
	if (locale === "pt") return pt_cj_meta_description(inputs)
	if (locale === "ja") return ja_cj_meta_description(inputs)
	return zh_cj_meta_description(inputs)
};